/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'

const entity = {
  name: {},
  langs: {},
  img: {},
  content: {},
  area: {},
  way: {}
}
const config = {
  load: async function (filter) {
    return [{ name: 'champaign1', langs: 'de', img: '', content: '123465', area: '江苏', way: '渠道1' },
      { name: 'champaign2', langs: 'zh', img: '', content: '654321', area: '湖北', way: '渠道2' }
    ]
  }
}
export default IKDataEntity.ModelFactory(entity, config)
